import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import _ from 'lodash'
import { SectionCard } from '~/components/SectionCard'
import { getSite } from '~/features/sites/service'
import { Button, Flex } from '@radix-ui/themes'
import { EmptyState } from '~/components/EmptyState'
import { listSiteMetrics } from '~/features/dashboarding/service'
import { useTranslation } from 'react-i18next'
import { ScrollablePageLayout } from '~/components/ScrollablePageLayout'
import { ConsumptionAndLeaksSection } from '~/features/stations/components/ConsumptionAndLeakSection'
import { StationConsumptionChartSection } from '~/features/dashboarding/components/StationConsumptionChartSection'

const Page = () => {
  const { t } = useTranslation(['sites', 'sidenav'])
  const { siteID } = Route.useParams()

  const { data: site } = useSuspenseQuery({
    queryKey: ['site', siteID],
    queryFn: () => getSite({ siteId: siteID })
  })

  const { data: metrics } = useSuspenseQuery({
    queryKey: ['site-metrics', siteID],
    queryFn: () => listSiteMetrics(siteID)
  })

  const emptyState = (
    <SectionCard title={t('dashboard.title')} height={'100%'}>
      <EmptyState
        title={t('dashboard.emptyState.title')}
        description={t('dashboard.emptyState.description')}
        afterBody={
          <Link to={`/sites/$siteID/config/stations/new`} params={{ siteID }}>
            <Button size={'2'}>{t('dashboard.emptyState.addEntryStation')}</Button>
          </Link>
        }
      />
    </SectionCard>
  )

  return (
    <ScrollablePageLayout title={t('navigation.readings', { ns: 'sidenav' })}>
      {site.stations.length === 0 ? (
        emptyState
      ) : (
        <Flex direction="column" gap="4">
          <StationConsumptionChartSection
            title={"Distribution de l'eau mesurée"}
            stations={site.stations}
            chartType="area"
            partitionKey="station_type"
            partitionsOptions={[
              { key: 'entry', label: t('stations.types.entry', { count: 10 }) },
              { key: 'usage', label: t('stations.types.usage', { count: 10 }) },
              { key: 'discharge', label: t('stations.types.discharge', { count: 10 }) }
            ]}
          />
          {metrics.map((metric) => (
            <StationConsumptionChartSection
              key={metric.id}
              chartKey={metric.id}
              title={metric.name}
              stations={site.stations.filter((s) =>
                metric.stationOperations.map((op) => op.stationId).includes(s.id)
              )}
              chartType={metric.chartType}
              partitionKey={null}
              siteID={siteID}
              metricID={metric.id}
            />
          ))}
          {site.stations.map((station) => (
            <ConsumptionAndLeaksSection key={station.id} stationNameAsTitle station={station} />
          ))}
        </Flex>
      )}
    </ScrollablePageLayout>
  )
}
export const Route = createFileRoute('/sites/$siteID/readings')({
  component: Page
})
